<template>
  <el-dialog
      :title="$t('text.googleKey')"
      :visible="showGoogleKeyDialog"
      width="600px"
      @open="handleDialogOpen"
      @close="handleDialogClose"
      :close-on-click-modal="false"
  >
    <el-row v-loading="loading">
      <el-col
          :span="20"
      >
        <el-input
            :readonly="true"
            :value="googleKey"
        />
      </el-col>
      <el-col
          :span="4"
          style="text-align: center;"
      >
        <el-button
            @click="handleCopyClick"
        >
          {{ $t('text.copy') }}
        </el-button>
      </el-col>
    </el-row>
    <div
        slot="footer"
        class="dialog-footer"
    >
      <el-button type="primary" @click="handleCloseClick">{{ $t('text.close') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "GoogleKeyDialog",
  data() {
    return {
      loading: false,
      googleKey: "",
    };
  },
  props: {
    showGoogleKeyDialog: {
      type: Boolean,
      default: false
    },
    userId: {
      type: String,
      default: false
    }
  },
  methods: {
    handleDialogOpen() {
      this.loading = true;

      let error = "";
      this.$axios
          .get("/sysUserInfo/selectUserGoogleKey", {params: {id: this.userId}})
          .then((res) => {
            if (res.code === 200) {
              this.googleKey = res.data;
              return true;
            } else {
              error = res.msg;
              return false;
            }
          })
          .catch((res) => {
            error = res.msg;
          })
          .finally(() => {
            this.loading = false;
            if (error !== "") {
              this.$notify.error({
                title: this.$t('text.prompt'),
                message: error
              });
              this.closeDialog();
            }
          });
    },
    handleDialogClose() {
      this.closeDialog();
    },
    handleCopyClick() {
      navigator.clipboard.writeText(this.googleKey)
          .then(() => {
            this.$message.success(this.$t('message.copySuccess'));
          })
          .catch(() => {
            this.$message.error(this.$t('message.copyError'));
          });
    },
    handleCloseClick() {
      this.closeDialog();
    },
    closeDialog() {
      this.googleKey = "";
      this.$emit("update:showGoogleKeyDialog", false);
    }
  }
};
</script>